import { Authenticated, useGo, useList, useTranslate } from "@refinedev/core";
import { DeleteButton, EditButton, List } from "@refinedev/antd";
import { useOrganization } from "hooks/useOrganization";
import { AssetLibrary } from "pages/media/types";
import { Button, Space, Table, TableColumnsType } from "antd";
import useIsAdmin from "hooks/useIsAdmin";
import { GlobeSimpleIcon } from "@phosphor-icons/react";

const AssetLibraries = ({ showPublic }: { showPublic?: boolean }) => {
  // using uselist and the list detail in refine, we build our list component
  const { organization } = useOrganization({});
  const t = useTranslate();
  const isAdmin = useIsAdmin();
  const go = useGo();

  const resource =
    showPublic && isAdmin
      ? `media/asset_libraries`
      : `media/${organization?.id}/asset_libraries`;
  const enabled = showPublic && isAdmin ? true : !!organization?.id;

  const {
    data: assetLibraries,
    isLoading: isLoadingAssetLibraries,
    refetch,
  } = useList<AssetLibrary>({
    resource,
    queryOptions: {
      enabled,
    },
  });

  const columns: TableColumnsType<AssetLibrary> = [
    {
      title: t("assetLibraries.index.name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("assetLibraries.index.organization"),
      dataIndex: "organization_id",
      key: "organization_id",
    },
    {
      title: t("assetLibraries.index.actions"),
      key: "actions",
      width: 1,
      render: (_: any, _record: AssetLibrary) => (
        <div>
          <Space>
            <EditButton
              size="small"
              shape="round"
              accessControl={{ enabled: false }}
              recordItemId={_record.id}
            >
              {t("assetLibraries.index.edit")}
            </EditButton>
            <DeleteButton
              size="small"
              shape="round"
              resource={`media/asset_libraries`}
              accessControl={{ enabled: false }}
              recordItemId={_record.id}
              onSuccess={() => refetch()}
            >
              {t("assetLibraries.index.delete")}
            </DeleteButton>
          </Space>
        </div>
      ),
    },
  ];
  return (
    <Authenticated key="asset-libraries">
      <List
        headerButtons={
          isAdmin && showPublic ? (
            <Button
              type="primary"
              onClick={() => go({ to: "create" })}
              icon={
                <GlobeSimpleIcon
                  style={{ verticalAlign: "text-top" }}
                  size={24}
                />
              }
            >
              {t("actions.create")}
            </Button>
          ) : (
            <Button type="primary" onClick={() => go({ to: "create" })}>
              {t("actions.create")}
            </Button>
          )
        }
      >
        <Table
          columns={columns}
          dataSource={assetLibraries?.data}
          loading={isLoadingAssetLibraries}
        ></Table>
      </List>
    </Authenticated>
  );
};

export default AssetLibraries;
